import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup } from 'reactstrap';
import { Dropdown } from '@ami/react/core';
import { ListGroup, ListGroupItem } from '@ami/react/core';
import _ from 'lodash';
import { NotificationManager } from 'react-notifications';
import { allExceptIds } from '@ami/react/core';

export class DealerUserContactSelection extends Component {
  constructor(props) {
    super(props);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  static propTypes = {
    userIds: PropTypes.arrayOf(PropTypes.string),
    onUpdate: PropTypes.func.isRequired,
    users: PropTypes.array.isRequired,
  };

  state = {
    availableUsers: [],
    keyedAvailableUsers: null,
  };

  async componentDidMount() {
    const availableUsers = this.props.users;
    this.setState({
      availableUsers,
      keyedAvailableUsers: _.keyBy(availableUsers, (x) => x.id),
    });
  }

  removeItem(item) {
    this.props.onUpdate(this.props.usersIds.filter((x) => x !== item));
  }

  addItem(selectedId) {
    if (!selectedId) return;
    if (this.props.usersIds.find((x) => x === selectedId))
      return NotificationManager.warning('User has been added already');
    this.props.onUpdate([...this.props.usersIds, selectedId]);
  }

  getAvailableUsersToAdd(availableUsers) {
    return allExceptIds(availableUsers, this.props.usersIds);
  }

  render() {
    const { usersIds } = this.props;
    const { keyedAvailableUsers } = this.state;
    return (
      <FormGroup>
        <ListGroup label="Dealer Contacts">
          {keyedAvailableUsers &&
            usersIds.map((id) => (
              <ListGroupItem
                heading={keyedAvailableUsers[id].fullName}
                onRemove={() => this.removeItem(id)}
                key={id}
              />
            ))}
        </ListGroup>
        <div className="row">
          <div className="col">
            <Dropdown
              placeholder="Select a dealer contact to add..."
              items={this.getAvailableUsersToAdd(this.state.availableUsers).map(
                (x) => ({ id: x.id, label: x.fullName })
              )}
              onChange={(selectedId) => this.addItem(selectedId)}
              className="w-full"
            />
          </div>
        </div>
      </FormGroup>
    );
  }
}
